import layout1 from './layout1/Layout1Config';
import layoutMarketing from './layout-marketing/LayoutMarketingConfig';
import layoutMarketingQuill from './layout-marketing/LayoutMarketingQuillConfig';
import layoutMarketingV2 from './layout-marketing-v2/LayoutMarketingV2Config';

const themeLayoutConfigs = {
  layout1,
  layoutMarketing,
  layoutMarketingQuill,
  layoutMarketingV2
};

export default themeLayoutConfigs;
